module.exports = new __parcel__URL__("mythical_asteroid.354033f9.png").toString();